const LOGO_SRC = "/assets/cozyhome-logo.webp";

// Composant Logo global unique — une seule source d'image pour tout le projet.
// boxed=true ajoute un encart beige (bg-cream) discret pour les fonds sombres/colorés.
export const Logo = ({ className = "h-10 w-auto", boxed = false, boxClassName = "" }) => {
  const img = <img data-testid="cozyhome-logo" src={LOGO_SRC} alt="CozyHome" className={`object-contain ${className}`} />;
  if (!boxed) return img;
  return (
    <span className={`inline-flex shrink-0 items-center justify-center rounded-2xl bg-cream ${boxClassName || "px-3 py-2"}`}>
      {img}
    </span>
  );
};
